




























// Retrofitted from:
// https://github.com/graphql/graphql-playground/blob/71fc40bbb8128a0b5202db4addc5b972f093cce2/packages/graphql-playground-react/src/components/Playground/TracingRow.tsx

import Vue, { PropType } from 'vue';
export default Vue.extend({
  name: 'TracingRow',
  props: {
    path: {
      type: Array as PropType<Array<number | string>>,
      required: true,
    },
    startOffset: {
      type: Number, // nanoseconds
      required: true,
    },
    duration: {
      type: Number, // nanoseconds
      required: true,
    }
  },
  data() {
    return {
      factor: 1000 * 1000,
    };
  },
  computed: {
    offsetLeft(): number {
      return this.startOffset / this.factor;
    },
    barWidth(): number {
      return this.duration / this.factor;
    },
    rowStyles(): any {
      return {
        transform: `translateX(${this.offsetLeft}px)`,
      };
    },
  },
  errorCaptured(error) {
    console.log(error);
  },
  methods: {
    printDuration(nanoSeconds: number) {
      const microSeconds = Math.round(nanoSeconds / 1000)
      if (microSeconds > 1000) {
        const ms = Math.round(microSeconds / 1000)
        return `${ms} ms`
      }

      return `${microSeconds} µs`;
    }
  }
});
